// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media{height:100px;width:150px}.media .media-item{height:100%;width:100%}.media .overlay{background-color:rgba(0,0,0,.6)}", ""]);
// Exports
module.exports = exports;
